import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import Helmet from "react-helmet"

import MainAppChrome from "../../chrome/MainAppChrome"
import Hero from "../../../components/ui-Hero"
import HeroTitle from "../../../components/ui-HeroTitle"
import PageSection from "../../../components/ui-PageSection"
import { Container, Row, Col } from "ui-Grid"
import { Text, Title } from "ui-Text"

import Button from "@material-ui/core/Button"

import BioSection from "../../BioSection"
import ServicePaymentOptions from "../../ServicePaymentOptions"
import ServiceCallInstructions from "../../ServiceCallInstructions"
import StructuredData from "../../../components/StructuredData"

import { SCHEDULE_URL, ASK_URL } from "../../../lib/urls"

const styleSheet = theme => ({
  pricing: {
    margin: [theme.spacing.unit * 2, 0],

    [theme.breakpoints.up("md")]: {
      margin: [0, theme.spacing.unit * 2],
    },
  },

  scheduleButton: {
    margin: [theme.spacing.unit, 0],
  },

  scheduleSection: {
    marginTop: theme.spacing.unit * 3,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
})

const structuredData = {
  "@context": "http://schema.org/",
  "@type": "Service",
  name: "In Home Postpartum Consultation",
  description:
    "This is a 60-90 minute in home consultation for mothers (and their partners) that need breastfeeding guidance. You may feel you lack milk, have pain when nursing, or face other challenges; I can help.",
  offers: {
    "@type": "Offer",
    priceCurrency: "USD",
    price: "135.00",
    priceValidUntil: "2019-1-1",
    url: "https://jalactation.com/breastfeeding-support/in-home-consultation",
  },
}

function PostpartumConsultation({ classes }) {
  return (
    <MainAppChrome>
      <Helmet>
        <title>In Home Postpartum Consultation </title>
        <meta
          name="description"
          content="
              This is a 60-90 minute in home consultation for mothers (and their partners) that need
              breastfeeding guidance. You may feel you lack milk, have pain when nursing, or face
              other challenges; I can help."
        />
      </Helmet>
      <Hero>
        <HeroTitle
          title="In Home Postpartum Consultation"
          subTitle="
              This is a 60-90 minute in home consultation for mothers (and their partners) that need
              breastfeeding guidance. You may feel you lack milk, have pain when nursing, or face
              other challenges; I can help.
            "
        />

        <Container wide flex className={classes.scheduleSection}>
          <Button
            color="primary"
            variant="outlined"
            href={SCHEDULE_URL}
            target="_blank"
            className={classes.scheduleButton}
          >
            Schedule In Home Help
          </Button>
          <Button color="primary" href={ASK_URL} className={classes.scheduleButton}>
            Ask a Question
          </Button>
          <Text paragraph={false} className={classes.pricing}>
            $135 for the first visit and $60 for follow ups.
          </Text>
          <StructuredData data={structuredData} />
        </Container>
      </Hero>

      <PageSection gutterTop gutterBottom>
        <Container wide>
          <Row>
            <Col md={7} xs={12}>
              <Title paragraph>What can you expect during your consultation?</Title>

              <Text paragraph component="div">
                <ul>
                  <li>Oral exam to assess baby's mouth</li>
                  <li>Breast exam for mom</li>
                  <li>Breastfeeding position and latch are assessed</li>
                  <li>
                    Baby is weighed before and after the feeding to measure the amount of breast
                    milk consumed
                  </li>
                  <li>Demonstrate and develop a personalized Plan of Care</li>
                </ul>
              </Text>

              <Text paragraph>
                Following your visit, I will call or email you within 48 hours to see how you and
                baby are doing. I will send a report to your primary care provider(s) summarizing
                the consultation.
              </Text>

              <Text paragraph>$135 for the first visit and $60 for follow ups.</Text>
              <ServicePaymentOptions />
            </Col>
            <Col md={1} xs={12} />
            <Col lg={3} md={4} xs={12}>
              <ServiceCallInstructions />
            </Col>
          </Row>
        </Container>
      </PageSection>
      <BioSection />
    </MainAppChrome>
  )
}

export default withStyles(styleSheet)(PostpartumConsultation)



// WEBPACK FOOTER //
// ./src/views/pages/PostpartumConsultation/index.js